"use client";
import { Fragment } from "react";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";

import Ad from "@/components/ad";
import { isSection, removeDelimiter } from "@/lib/ingredientFunctions";

function* stepNumberGenerator() {
  let index = 0;
  while (true) {
    yield ++index;
  }
}

export default function RecipeDirectionsList({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);

  const gen = stepNumberGenerator();
  return (
    <div
      className="mx-4"
      {...ContentfulLivePreview.getProps({
        entryId: recipe?.sys.id,
        fieldId: "directions",
      })}
    >
      {updateRecipe?.directions?.map((item: any, index: number) => (
        <Fragment key={"direction-" + index}>
          {index === 3 && (
            <Ad
              id="Mobile_INR3_RP"
              className="my-8 max-h-[610px] min-h-[60px] min-w-[130px] max-w-[336px] text-center md:hidden"
              screen="MOBILE"
              useWithPartner="ATD"
            />
          )}

          {isSection(item) ? (
            <p className="break-inside-avoid pb-3 text-lg font-bold text-theme-primary-dark">
              {removeDelimiter(item)}
            </p>
          ) : (
            <p
              data-testid={"direction-" + index}
              className="flex break-inside-avoid gap-1 pb-2 text-theme-primary-dark"
            >
              <span className="flex-shrink-0 font-bold">
                Step {Number(gen.next().value)} -
              </span>
              {item.value}
            </p>
          )}
        </Fragment>
      ))}
    </div>
  );
}
